import { useState, useEffect } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import Button from "../../../../Elements/Button/Button.js";
import { BankIds } from "../Utils/Helper.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";

const WithdrawalRequestModal = ({
  userBalanceConverted,
  bankAccounts,
  userPhone,
  userData,
  feeSettings,
}) => {
  const { getTextByKey, getDirection, getLanguage } = useContent();

  //Display bank option for select
  const displayBankOption = (bank) => {
    return (
      getTextByKey(`payment-bank-${BankIds?.[bank?.BankId]}`) +
      " - ****" +
      bank?.BankAccountId
    );
  };

  //Display paypal option for select
  const displayPayPalOption = (bank) => {
    //display Paypal - email
    return "Paypal - " + bank?.AccountEmail;
  };

  const bankAccountsList = Object.values(bankAccounts);
  const paypalAccountsList = Object.values(userData?.User_PaypalAccounts || {});
  const defaultBank = bankAccountsList.find((bank) => bank?.defaultBank);
  const indexOfDefaultBank = bankAccountsList.indexOf(defaultBank) + 1;
  const defaultValueBank = "bank-" + indexOfDefaultBank;
  const [bankAccountDisplay, setBankAccountDisplay] = useState("");

  const [numOfStep, setNumOfStep] = useState(1);
  const [stepTitle, setStepTitle] = useState("payment-request-withdrawal");
  const [phoneNumber, setPhoneNumber] = useState(userPhone ? userPhone : "");
  const [withdrawalAmount, setWithdrawalAmount] = useState(0);
  const [selectBank, setSelectBank] = useState(defaultValueBank);
  const [isPayPal, setIsPayPal] = useState(false);
  const [bankIndexValue, setBankIndexValue] = useState(indexOfDefaultBank);
  const [selectedBankObject, setSelectedBankObject] = useState(defaultBank);
  const [minWithdrawalAmountAlert, setMinWithdrawalAmountAlert] =
    useState(false);
  console.log("bankAccounts", bankAccounts);
  //GetBankSelectBuilder
  const getBankSelectBuilder = async () => {
    const parameters = {
      culture: getLanguage(),
    };
    const response = await apiRequest(
      "Users",
      "GetBankSelectBuilder",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setBankAccountDisplay(response.data);
        console.log("bank", response);
      }
    }
  };

  useEffect(() => {
    getBankSelectBuilder();
  }, [userData]);
  const minimumWithdrawalAmount = feeSettings.MinWithdrawalAmountILS;
  const [loadingRequestButton, setLoadingRequestButton] = useState(false);

  const handleChangeBank = (bank) => {
    const bankIndexValue = bank.split("-")[1];
    const isPayPal = bank.split("-")[0] === "paypal" ? true : false;
    const type = isPayPal ? "paypal" : "bank";
    setIsPayPal(isPayPal);
    setBankIndexValue(bankIndexValue);
    setSelectedBankObject(
      isPayPal
        ? paypalAccountsList[bankIndexValue - 1]
        : bankAccountsList[bankIndexValue - 1]
    );
    setSelectBank(type + "-" + bankIndexValue);
  };

  const addOptionToSelect = (isPayPal, bankValue, index) => {
    const type = isPayPal ? "paypal" : "bank";
    const indexVal = index + 1;
    return <option value={type + "-" + indexVal}>{bankValue}</option>;
  };

  const getMinAmountText = (text) => {
    if (text.includes("#minimum-amount#")) {
      return text.replace("#minimum-amount#", minimumWithdrawalAmount);
    }
  };

  function truncateToTwoDecimals(num) {
    const str = num.toString();
    const decimalIndex = str.indexOf(".");
    if (decimalIndex === -1) return str; // No decimal point found
    return str.substring(0, decimalIndex + 3); // Extract two digits after the decimal point
  }

  const step1 = () => {
    return (
      <div className="modal-body JM-modal-body step step-1 withdrawal-model">
        <div className="account-balance">
          <div className="inside-box">
            <span className="text">
              {getTextByKey("payment-request-withdrawal")}
            </span>
            <span>
              <span className="currency">₪ ILS</span>{" "}
              <span className="amount">
                {truncateToTwoDecimals(userBalanceConverted)}
              </span>
            </span>
          </div>
        </div>

        <div id="transfer-amount">
          <div className="text">{getTextByKey("payment-amount-transfer")}:</div>
          <div className="input-group">
            <div className="input-group-prepend <%= CurrentDir %>">
              <span className="input-group-text">ILS</span>
            </div>
            <input
              onChange={(e) => setWithdrawalAmount(e.target.value)}
              id="Withdrawal_amount"
              className="form-cont"
              type="number"
              value={withdrawalAmount}
              min="35"
            />
          </div>
        </div>

        <div id="phone-number">
          <div className="text">{getTextByKey("phone")}:</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fas fa-phone"></i>
              </span>
            </div>
            <input
              onChange={(e) => setPhoneNumber(e.target.value)}
              id="Withdrawal_phone"
              className="form-cont"
              placeholder=""
              type="text"
              value={phoneNumber}
            />
          </div>
        </div>

        <div id="bank-account">
          <div className="text">{getTextByKey("payment-to-bank-account")}:</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fas fa-university"></i>
              </span>
            </div>
            <div
              className={`select-wrapper ${
                getDirection() === "rtl" ? "rtl" : ""
              }`}
            >
              <select
                value={selectBank}
                onChange={(e) => handleChangeBank(e.target.value)}
                className="select"
                id="Withdrawal_bankEntryId"
                tabIndex="8"
              >
                <option value="">Bank</option>
                {bankAccountsList &&
                  bankAccountsList.length > 0 &&
                  bankAccountsList.map((bank, index) => {
                    return addOptionToSelect(
                      false,
                      displayBankOption(bank),
                      index
                    );
                  })}
                {paypalAccountsList &&
                  paypalAccountsList.length > 0 &&
                  paypalAccountsList.map((bank, index) => {
                    return addOptionToSelect(
                      true,
                      displayPayPalOption(bank),
                      index
                    );
                  })}
              </select>
            </div>
          </div>
        </div>
        <div className="button-div">
          <Button
            className="new-button btn jm-button btn-primary step step-1 approve-withdrawal"
            onClick={() => changeToStep2()}
          >
            {getTextByKey("check-status-button")}
          </Button>
        </div>
        <div className="table-row one-field">
          {minWithdrawalAmountAlert && (
            <h3 id="errorMsg" className="label-danger">
              {getMinAmountText(getTextByKey("min-amount-alert"))}
            </h3>
          )}
          <div className="text">{getTextByKey("payment-5-days-notice")}</div>
        </div>
      </div>
    );
  };

  const changeToStep2 = () => {
    if (withdrawalAmount >= minimumWithdrawalAmount) {
      setMinWithdrawalAmountAlert(false);
      setStepTitle("payment-approve-request");
      setNumOfStep(2);
    } else {
      setMinWithdrawalAmountAlert(true);
    }
  };

  const changeToStep1 = () => {
    setNumOfStep(1);
    setStepTitle("payment-request-withdrawal");
  };

  const continueToStep3 = () => {
    createNewWithdrawalRequest();
  };

  const createNewWithdrawalRequest = async () => {
    setLoadingRequestButton(true);
    //convert bank index to long
    const convertedBankIndex = parseInt(bankIndexValue);
    const body = {
      Withdrawal_amount: withdrawalAmount,
      Withdrawal_Status: "PENDING",
      Withdrawal_userMail: userData.UserName,
      Withdrawal_phone: phoneNumber,
      Withdrawal_bankEntryId: convertedBankIndex,
      Withdrawal_account_type: isPayPal ? "paypal" : "bank",
    };

    const response = await apiRequest(
      "Withdrawals",
      "CreateNewWithdrawalRequest",
      body,
      "POST"
    );

    if (response.status === "success") {
      if (response.data) {
        setStepTitle("payment-confirm-request");
        setNumOfStep(3);
        setLoadingRequestButton(false);
      }
    }
  };

  const step2 = () => {
    return (
      <div className="modal-body step step-2">
        <div id="withdrawal-summery">
          <div className="summery-row">
            <span>{getTextByKey("payment-amount-transfer")} </span>
            <span className="amount blue" id="Amount">
              {withdrawalAmount}
            </span>
          </div>
          <div className="summery-row">
            <span>{getTextByKey("payment-to-bank-account")}</span>
            <span className="amount blue" id="verifyBankAccount">
              {isPayPal
                ? displayPayPalOption(selectedBankObject)
                : displayBankOption(selectedBankObject)}
            </span>
          </div>
          <div className="summery-row">
            <span>{getTextByKey("payment-sum-fee")}</span>
            <span className="amount" id="transferFee">
              {feeSettings &&
              withdrawalAmount >=
                feeSettings.WithdrawalMinAmountForFixedFeeInILS
                ? 0
                : feeSettings.WithdrawalFixedFeeInILS}
            </span>
          </div>
          <div className="summery-row gray">
            <span>{getTextByKey("Payment_Sum_Net")}</span>
            <span className="amount blue" id="verifyAmount">
              {" "}
              {feeSettings &&
              withdrawalAmount >=
                feeSettings.WithdrawalMinAmountForFixedFeeInILS
                ? withdrawalAmount
                : withdrawalAmount - feeSettings.WithdrawalFixedFeeInILS}
            </span>
          </div>
          <div className="actions">
            {!loadingRequestButton ? (
              <Button className="new-button" onClick={() => continueToStep3()}>
                {getTextByKey("payment-sum-approve")}
              </Button>
            ) : (
              <Button className="new-button">
                <Image name="preloader" ext="gif" />
              </Button>
            )}

            <Button className="new-button" onClick={() => changeToStep1()}>
              {getTextByKey("back-text")}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const reloadPage = () => {
    window.location.reload();
  };

  const step3 = () => {
    return (
      <div class="modal-body step step-3 withdrawal-approval">
        <div id="withdrawal-done">
          <Icon name="withdrawal-done" />
        </div>
        <div class="text">{getTextByKey("payment-request-final-notice")}</div>
        <div className="actions">
          <Button className="new-button" onClick={() => reloadPage()}>
            {getTextByKey("payment-request-ok")}
          </Button>
        </div>
      </div>
    );
  };

  const steps = [
    { function: step1() },
    { function: step2() },
    { function: step3() },
  ];

  return (
    <div className="withdrawal-request-modal">
      <div className="modal-header">
        <h3>{getTextByKey(stepTitle)}</h3>
      </div>
      <div className="modal-content withdrawal-model-wrapper">
        {steps[numOfStep - 1].function}
      </div>
    </div>
  );
};

export default WithdrawalRequestModal;
